import { HostListener, Component } from '@angular/core';

import { AuthService } from './shared/services/auth.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { CONFIGURATION } from './shared/configuration/configuration';
import { CheckboxControlValueAccessor } from '@angular/forms';

import { PageNavigationService } from './shared/services/page-navigation.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent{

  constructor(
    private _idle: Idle,
    private _authService: AuthService,
    private _pageNavigationService: PageNavigationService,
    ) {

    _idle.setIdle(CONFIGURATION.SESSIONTIMEOUT);
    _idle.setTimeout(CONFIGURATION.SESSIONTIMEOUT);
    _idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    _idle.onTimeout.subscribe(() => {
      this.reset();
      this._authService.logout();
    });
    this.reset();
  }

  // ngOnInit():void{
  //   console.log(Checkout);
  // }

  reset() {
    this._idle.watch();
  }


  // @HostListener('document:payment-error', ['$event'])
  // paymentError(){
  //   alert('Payment Cancelled');
  //   this._pageNavigationService.navigate(['plant-map/payment']);
  // }

}



// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/app.component.ts